// extracted by mini-css-extract-plugin
export default {"container":"WidgetDraggableOverlay_container__iW4mU"};